<template>
  <div class="container">
    <TemplateSearchNoData
      :keyword="keyword"
      :type="'slide'"
    />
  </div>
</template>

<script>
import TemplateSearchNoData from '@/components-v2/common/template-library/TemplateSearchNoData.vue'

export default {
  components: {
    TemplateSearchNoData,
  },
  props: {
    keyword: {
      type: String,
      default: '',
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.container {
  background: #F0F4FA;
  height: 100%;
}
</style>
